import React from 'react';
import { Button, DynamicForm } from 'components';
import useFormHandler from 'hooks/useFormHandler';
import { Props } from 'types/modals';
import Base from '../../base';
import schema from './schema';

const CreationWarningModal = ({ closing, onClose }: Props) => {
  const formHandler = useFormHandler(schema);

  return (
    <Base
      header="Create warning"
      closing={closing}
      onClose={onClose}
      size="md"
      footer={
        <Button
          text="Create"
          disabled={!formHandler.valid || formHandler.isSubmitting}
          onClick={() => {
            formHandler.setIsSubmitting(true);
            onClose(formHandler.data);
          }}
        />
      }
    >
      <div className="modal-residential-address">
        <DynamicForm handler={formHandler} />
      </div>
    </Base>
  );
};

export default CreationWarningModal;
